// «ذمم الموردين» inside the accounts module (HANDOFF §3: /accounts/payables ·
// board accounts/payables). Manager+ (HANDOFF §9 — payables are hidden below
// manager; the server answers 403 and drops the payables fields). The
// module flag is erp.accounts. Off ⇒ absent from menu and routes; a deep link
// lands on «اليوم» with the reason.

import type { RouteObject } from 'react-router-dom';
import { gate, type MenuItem } from '@/app/module-types';

export const PAYABLES_PATH = '/accounts/payables';
const g = gate({ flag: 'erp.accounts', minRole: 'manager' });

export const payablesRoutes: RouteObject[] = [
  { path: PAYABLES_PATH, lazy: () => import('./screens/Payables').then((m) => ({ Component: m.PayablesRoute })), handle: g },
];

export const payablesMenu: MenuItem[] = [{ key: 'payables', label: 'ذمم الموردين', to: PAYABLES_PATH, flag: 'erp.accounts', minRole: 'manager' }];

export { paymentVoucherHref, paymentVoucherViewHref, purchaseHref, PAYMENT_VOUCHER_ROUTE, PAYMENT_VOUCHER_PANEL } from './lib/links';
export type { PaymentVoucherPrefill } from './lib/links';
